import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Link } from 'react-router-dom'
import Label from '../texts/label'

const renderLink = (url = '', text = '') => {
  if (/^http|wwww/.test(url)) {
    return (
      <a href={url} target='_new' rel='no opener'>
        {url}
      </a>
    )
  } else {
    return <Link to={url}>{text}</Link>
  }
}

const Indicator = props => (
  <div
    className={classNames({
      indicator: true,
      error: props.error,
      'loud-indicator': props.isLoud,
      [props.className]: props.className
    })}
  >
    <Label shyLabel={props.shyLabel}>{props.labelText}</Label>
    <p
      className={classNames({
        value: true,
        upper: props.upperValue
      })}
    >
      {props.smallText ? <small>{props.smallText}</small> : null}
      {props.url ? renderLink(props.url, props.titleText) : props.titleText}
      {props.clarifyText ? (
        <span className='clarify-text'>{props.clarifyText}</span>
      ) : null}
    </p>
    {props.children}
  </div>
)

Indicator.propTypes = {
  labelText: PropTypes.string,
  titleText: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  smallText: PropTypes.string,
  isLoud: PropTypes.bool,
  url: PropTypes.string,
  upperValue: PropTypes.bool,
  clarifyText: PropTypes.string,
  shyLabel: PropTypes.bool,
  error: PropTypes.bool
}

export default Indicator



// WEBPACK FOOTER //
// ./src/ui/texts/indicator.js